import { Component, Input, OnInit } from '@angular/core';
import { Icon } from '@types-custom/models/ui/icon-model';
import { ICardAgentsModel } from '@types-custom/models/ui/card-agents-model';
import { DrawerPanelService } from '@ui-core/services/drawer-panel/drawer-panel.service';
import { ITimeLineGraphicModel } from '@types-custom/models/ui/chart-line-color-model';

@Component({
  selector: 'panel-agents',
  templateUrl: './panel-agents.component.html',
  styleUrls: ['./panel-agents.component.scss'],
})
export class PanelAgentsComponent implements OnInit {
  Icon = Icon;
  cards: ICardAgentsModel[] = [];
  dataGraphicList: ITimeLineGraphicModel;
  colorScale: any = [{}];
  totalAgents = 0;
  totalPoliceAgents = 0;
  totalTransitAgents = 0;
  @Input() serviceDataSource: any;

  constructor(private drawerPanelService: DrawerPanelService) {}

  ngOnInit(): void {
    this.totalAgents = this.cards.length ?? 0;
    this.totalPoliceAgents =
      this.cards.filter((e) => e.agentType === 'police').length ?? 0;
    this.totalTransitAgents =
      this.cards.filter((e) => e.agentType === 'transit').length ?? 0;

    this.serviceDataSource.getMeasurementAgents().subscribe((res: any) => {
      this.setGraphicAgents(res);
    });
  }

  openModal(card: ICardAgentsModel): void {
    this.drawerPanelService.collapseDrawer(true);
    card?.cardMapLink?.markerDispatcher.next(card.cardMapLink.markerModel);
  }

  setGraphicAgents(data: any): void {
    const sortedData = data
      .map((e: any) => {
        return { time: ('0' + e.time).slice(-5), value: e.value };
      })
      .sort((a: any, b: any) => a.time.localeCompare(b.time));

    this.dataGraphicList = {
      data: sortedData,
      label: 'agentes',
      labelX: 'Horas',
      labelY: 'Agentes activos',
    };
    this.colorScale = [{ minValue: 0, maxValue: 10000, color: '#C37E20' }];
  }
}
